import { getApi } from './api';
import {
  advantageClub,
  advantageClubBalance,
  advantageClubHistory,
  advantageClubWithdrawManual,
  auth,
  clubPointValueInBrCurrency,
  common,
  customers,
  customersPosition,
  dashboard,
  email,
  exporter,
  importer,
  integration,
  logs,
  orderOrigin,
  orders,
  orderStatus,
  mobileOrderStatus,
  ordersTypes,
  product,
  reports,
  sellers,
  superadmin,
  system,
  databaseManagement,
  templates,
  tenantCustomLibs,
  datasync
} from './endpoints';
import ApiCore from './utilities/core';

export async function signinApi(login: string, password: string) {
  const api = await getApi();
  return api
    .post(auth['/login'], { login, password })
    .then((response: any) => ({ response }))
    .catch((error: any) => ({ error }));
}

export const signInSmartsellApi = new ApiCore({
  url: auth['/login'],
});

export async function signinByTokenReq(token: string) {
  const api = await getApi();
  return api
    .post(
      auth['/user'],
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )
    .then((response: any) => ({ response }))
    .catch((error: any) => ({ error }));
}

export async function logoutReq() {
  const api = await getApi();
  return api
    .post(auth['/logout'])
    .then((response: any) => ({
      response,
    }))
    .catch((error: any) => ({
      error,
    }));
}

export async function refreshReq(token: string) {
  const api = await getApi();
  return api
    .post(auth['/refresh'], {
      token,
    })
    .then((response: any) => ({
      response,
    }))
    .catch((error: any) => ({
      error,
    }));
}

export async function usersReqIndex() {
  const api = await getApi();
  return api
    .get(system['/roles'])
    .then((response: any) => ({
      response,
    }))
    .catch((error: any) => ({
      error,
    }));
}

export const userApi = new ApiCore({
  url: auth['/user'],
});

export const externalLoginApi = new ApiCore({
  url: auth['/external/login'],
});

export const visitRoutineAPI = new ApiCore({
  url: common['/visit_routines'],
});

export const generateVisitScheduledFromRoutinesAPI = new ApiCore({
  url: common['/visit_scheduled/generate_from_visit_routines'],
});

export const visitRoutineSellerSummaryAPI = new ApiCore({
  url: common['/visit_routines/sellers_summary'],
});

export const reconcileRoutinesAPI = new ApiCore({
  url: common['/visit_routines/reconcile'],
});

export const visitMotiveAPI = new ApiCore({
  url: common['/visit_motives'],
});

export const visitScheduledAPI = new ApiCore({
  url: common['/visit_scheduled'],
});

export const formAPI = new ApiCore({
  url: common['/forms'],
});

export const audienceAPI = new ApiCore({
  url: common['/audience'],
});

export const audienceAutomatedAPI = new ApiCore({
  url: common['/audience/automated'],
});

export const audienceAutomatedRunAPI = new ApiCore({
  url: common['/audience/automated'],
});

export const audienceUsersAPI = new ApiCore({
  url: common['/audience/users'],
});

export const audienceRemoveParticipantsAPI = new ApiCore({
  url: common['/audience/remove-participants'],
});

export const messageApi = new ApiCore({
  url: common['/messages'],
});

export const sandboxTestCodeApi = new ApiCore({
  url: common['/sandbox/test-code'],
});

export const goalsReq = new ApiCore({
  url: common['/goals'],
});

export const formQuestionApi = new ApiCore({
  url: common['/form-question'],
});

export const visitHistoryApi = new ApiCore({
  url: common['/visit_history'],
});

export const marketingResearchApi = new ApiCore({
  url: common['/marketing-research'],
});

export const marketingResearchReturnsApi = new ApiCore({
  url: common['/marketing-research-returns'],
});

export const branchApi = new ApiCore({
  url: common['/branch'],
});

export const tenantManagerApi = new ApiCore({
  url: common['/tenant-manager'],
});

export const tenantSupervisorApi = new ApiCore({
  url: common['/tenant-supervisor'],
});

export const SmartsellEnvApi = new ApiCore({
  url: common['/smartsell-environments'],
});

export const dashboardEtlsalesConsolidated = new ApiCore({
  url: dashboard['/etl/sales-consolidated'],
});

export const dashboardEtlSellersRankingReq = new ApiCore({
  url: dashboard['/etl/sellers-ranking'],
});

export const dashboardEtlProductsEtl = new ApiCore({
  url: dashboard['/etl/products-orders'],
});

export const dashboardEtlCustomersEtl = new ApiCore({
  url: dashboard['/etl/customers-orders'],
});

export const dashboardLog = new ApiCore({
  url: dashboard['/log'],
});

export const dashboardSettingsApi = new ApiCore({
  url: dashboard['/settings'],
});

export const goalsReqEtl = new ApiCore({
  url: dashboard['/etl/goals'],
});

export const marketingResearchMetricsApi = new ApiCore({
  url: dashboard['/marketing-research-metrics'],
});

export const visitMetricsApi = new ApiCore({
  url: dashboard['/visit-metrics'],
});

export const orderOriginReq = new ApiCore({
  url: orderOrigin[''],
});

export const ordersTypesApi = new ApiCore({
  url: ordersTypes[''],
});

export const customersApi = new ApiCore({
  url: customers[''],
});

export const newCustomersApi = new ApiCore({
  url: customers['/new-customer'],
});

export const newCustomersTransactionApi = new ApiCore({
  url: customers['/new-customer-log-transaction'],
});

export const mixCustomersGetGroupedApi = new ApiCore({
  url: customers['/mix/grouped'],
});

export const mixCustomersUpdateOrInsertApi = new ApiCore({
  url: customers['/mix/update-or-insert'],
});

export const mixCustomersRemoveApi = new ApiCore({
  url: customers['/mix/remove'],
});

export const customersPositionReq = new ApiCore({
  url: customersPosition[''],
});

export const sellersApi = new ApiCore({
  url: sellers[''],
});

export const goalsManyReq = new ApiCore({
  url: sellers['/goals-many'],
});

export const getIntegrationLogs = new ApiCore({
  url: integration['/log'],
});

export const integrationConfigReq = new ApiCore({
  url: integration['/config'],
});

export const tempFilesPaginatedApi = new ApiCore({
  url: system['/temp-files'],
});

export const tempFilesTemporaryUrlApi = new ApiCore({
  url: system['/temp-files/temporary-url'],
});

export const databaseManagementAvailableTablesApi = new ApiCore({
  url: databaseManagement['/available-tables'],
});

export const databaseManagementExportAsFileApi = new ApiCore({
  url: databaseManagement['/export-as-file'],
});

export const databaseManagementUpdateFromFileApi = new ApiCore({
  url: databaseManagement['/update-from-file'],
});

export const databaseManagementDownloadLatestExportApi = new ApiCore({
  url: databaseManagement['/download-latest-export'],
});

export const getIntegrationModelsApi = new ApiCore({
  url: integration['/models'],
});

export const getFastmanagerUrlsApi = new ApiCore({
  url: integration['/fastmanager/urls'],
});

export const usersReq = new ApiCore({
  url: system['/users'],
});

export const apiKeysReq = new ApiCore({
  url: system['/api-keys'],
});

export async function showApiKeyReq(code: string, password: string) {
  try {
    const api = await getApi();
    return await api.post(`${system['/api-keys']}/${code}/show`, { password });
  } catch (error) {
    return error;
  }
}

export async function deleteApiKeyReq(code: string, password: string) {
  try {
    const api = await getApi();
    return await api.delete(`${system['/api-keys']}/${code}`, {
      data: { password },
    });
  } catch (error) {
    return error;
  }
}

export const resetUserPasswordReq = new ApiCore({
  url: system['/users/reset-password'],
});

export const rolesReq = new ApiCore({
  url: system['/roles'],
});

export const orderPendenciesApi = new ApiCore({ url: orders['/pendencies'] });
export const groupedOrderPendenciesApi = new ApiCore({ url: orders['/pendencies/grouped'] });

export const orderApprovalGroupsApi = new ApiCore({
  url: orders['/approval-groups'],
});

export const accessBlocksApi = new ApiCore({
  url: system['/access-control/blocks'],
});

export const permissionsReq = new ApiCore({
  url: system['/permissions'],
});

export const tasksReq = new ApiCore({
  url: system['/tasks'],
});

export const tasksDoneReq = new ApiCore({
  url: system['/tasks/done'],
});

export const smartbannersReq = new ApiCore({
  url: system['/smartbanners'],
});

export const parametersApi = new ApiCore({
  url: system['/parameters'],
});

export const sellersParametersApi = new ApiCore({
  url: system['/sellers-parameters'],
});

export const newSellerParameterByReferenceReq = new ApiCore({
  url: system['/new-seller-parameter-by-reference'],
});

export const motivesReq = new ApiCore({
  url: system['/motives'],
});

export const motivesByActionsReq = new ApiCore({
  url: system['/motives-by-actions'],
});

export const motivesByActionsDeleteReq = new ApiCore({
  url: system['/motives-by-actions/delete'],
});

export const actionsReq = new ApiCore({
  url: system['/actions'],
});

export const communicationByActionAndOrderReq = new ApiCore({
  url: system['/communication-by-action-and-order'],
});

export const communicationByActionAndOrderDeleteReq = new ApiCore({
  url: system['/communication-by-action-and-order/delete'],
});

export const commGroupReq = new ApiCore({
  url: system['/communication-group'],
});

export const commAutoReq = new ApiCore({
  url: system['/communication-automation'],
});

export const ediLayoutApi = new ApiCore({
  url: system['/edi-layout'],
});

export const ediCustomersApi = new ApiCore({
  url: system['/edi-customers'],
});

export const ediAddCustomersApi = new ApiCore({
  url: system['/edi-add-customers'],
});

export const ediRemoveCustomersApi = new ApiCore({
  url: system['/edi-remove-customers'],
});

export const ediPaymentConditionsUpsertApi = new ApiCore({
  url: system['/edi-payment-condition/upsert'],
});

export const ediPaymentConditionsEditApi = new ApiCore({
  url: system['/edi-payment-condition/edit'],
});

export const ediPaymentConditionsDeleteManyApi = new ApiCore({
  url: system['/edi-payment-condition/delete-many'],
});

export const ediPaymentConditionsPaginatedApi = new ApiCore({
  url: system['/edi-payment-condition/paginated'],
});

export const getParametersRequiredToEdi = new ApiCore({
  url: system['/edi-layout-parameters-required'],
});

export const getSupervisedSellers = new ApiCore({
  url: system['/supervision-of-sellers/get-paginated'],
});

export const addSellersForSupervision = new ApiCore({
  url: system['/supervision-of-sellers/add-sellers'],
});

export const removeSellersFromSupervision = new ApiCore({
  url: system['/supervision-of-sellers/remove-sellers'],
});

export const sellerLockApi = new ApiCore({
  url: system['/smartsell/sync/lock'],
});

export const smartsellAppVersionLinkAudienceApi = new ApiCore({
  url: system['/smartsell/app-version/link-audience'],
});

export const smartsellAppVersionsApi = new ApiCore({
  url: system['/smartsell/app-version/versions'],
});

export const authSettingsAPI = new ApiCore({
  url: system['/auth-settings'],
});

export const getAuthSettingByTenantIdAPI = new ApiCore({
  url: system['/auth-settings/tenant_id'],
});

export const smartsellDbTablesAPI = new ApiCore({
  url: system['/smartsell/db-tables'],
});

export const smartsellDbTableColumnsAPI = new ApiCore({
  url: system['/smartsell/db-table-columns'],
});

export const templatesReq = new ApiCore({
  url: templates['/templates'],
});

export const templateParametersReq = new ApiCore({
  url: templates['/template-parameters'],
});

export const getTemplatesParametersPaginated = new ApiCore({
  url: templates['/template-parameters/paginated'],
});

export const getEdiTemplatesParametersPaginated = new ApiCore({
  url: templates['/template-parameters/ediPaginated'],
});

export const getSpecificTemplatesParametersByName = new ApiCore({
  url: templates['/template-parameters/get-by-name'],
});

export const communicationLogs = new ApiCore({
  url: logs['/communication'],
});

export const orderChangeLogs = new ApiCore({
  url: logs['/order-change'],
});

export const emailSendCommAutomationReq = new ApiCore({
  url: email['/send/communication-automation'],
});

export const emailLogsApi = new ApiCore({
  url: email['/logs'],
});

export const emailSmtpApi = new ApiCore({
  url: email['/smtp/config'],
});

export const emailSendApi = new ApiCore({
  url: email['/send'],
});

export const tenantResendingEmailApi = new ApiCore({
  url: email['/tenant-resend'],
});

export const checkIfUseEmailSendingApi = new ApiCore({
  url: email['/check-if-use-email-sending'],
});

export const reportFunctionsApi = new ApiCore({
  url: reports['/functions'],
});

export const reportsApi = new ApiCore({
  url: reports['/jasper/bases'],
});

export const downloadJrxmlFile = new ApiCore({
  url: reports['/jasper/get-jrxml-file'],
});

export const advantageClubAPI = new ApiCore({
  url: advantageClub[''],
});

export const advantageClubHistoryGET = new ApiCore({
  url: advantageClubHistory[''],
});

export const advantageClubBalanceGET = new ApiCore({
  url: advantageClubBalance[''],
});

export const advantageClubWithdrawManualPOST = new ApiCore({
  url: advantageClubWithdrawManual[''],
});

export const clubPointsValueInBrCurrencyApi = new ApiCore({
  url: clubPointValueInBrCurrency[''],
});

export const productAPI = new ApiCore({
  url: product['/p'],
});

export const productManagementAPI = new ApiCore({
  url: product['/catalog'],
});

export const productImagesAPI = new ApiCore({
  url: product['/images'],
});

export const productImagesAppendAPI = new ApiCore({
  url: `${product['/images']}/product`,
});

export const productImagesByProductAPI = new ApiCore({
  url: `${product['/images']}/product`,
});

export const productImageByIdAPI = new ApiCore({
  url: `${product['/images']}/id`,
});

export const productSellerAPI = new ApiCore({
  url: product['/seller'],
});

export const productSellerDeleteAPI = new ApiCore({
  url: product['/seller/delete-many'],
});

export const productTabPriceCodesAPI = new ApiCore({
  url: product['/pricetables-codes'],
});

export const getImporterLogs = new ApiCore({
  url: importer['/logs'],
});

export const importerAPI = new ApiCore({
  url: importer[''],
});

export const getExporterLogs = new ApiCore({
  url: exporter['/logs'],
});

export const exporterApi = new ApiCore({
  url: exporter[''],
});

export const getAvailableTablesForExporter = new ApiCore({
  url: exporter['/get-available-tables'],
});

export const tenantCustomLibsVersionsApi = new ApiCore({
  url: tenantCustomLibs['/versions'],
});

export const tenantCustomLibsApi = new ApiCore({
  url: tenantCustomLibs['/libs'],
});

export const tenantCustomVersionDownloadApi = new ApiCore({
  url: tenantCustomLibs['/version-download'],
});

export const unifiedOrdersApi = new ApiCore({ url: orders['/unified'] });

export const ordersApi = new ApiCore({
  url: orders[''],
});

export const paymentConditionApi = new ApiCore({
  url: orders['/payment-condition/api'],
});

export const paymentMethodApi = new ApiCore({
  url: orders['/payment-method/api'],
});

export const billingUnitApi = new ApiCore({
  url: orders['/billing-units'],
});

export const orderTypesApi = new ApiCore({
  url: orders['/types'],
});

export const orderFractionalItemsApi = new ApiCore({
  url: orders['/fractional-items'],
});

export const orderStatusApi = new ApiCore({
  url: orderStatus[''],
});

export const mobileOrderStatusApi = new ApiCore({
  url: mobileOrderStatus[''],
});

export const datasyncAPI = new ApiCore({
  url: datasync[''],
});

export const datasyncLogsAPI = new ApiCore({
  url: datasync['/logs/paginated'],
});

export const datasyncTypesAPI = new ApiCore({
  url: datasync['/types/paginated'],
});

export const tenantsReq = new ApiCore({
  url: superadmin['/tenants'],
});

export const superContactsApi = new ApiCore({
  url: superadmin['/contacts'],
});

export const superContactsReq = new ApiCore({
  url: superadmin['/contacts'],
});

export const runMigrationsAPI = new ApiCore({
  url: superadmin['/tenant/run-migrations'],
});

export const runSeedsAPI = new ApiCore({
  url: superadmin['/tenant/run-seeds'],
});

export const createUsersFromSellersAPI = new ApiCore({
  url: superadmin['/tenant/create-users-from-sellers'],
});

export const systemLogsApi = new ApiCore({
  url: superadmin['/system/logs'],
});

export const integrationModels = new ApiCore({
  url: superadmin['/integration/models'],
});

export const integrationModelsReq = new ApiCore({
  url: superadmin['/integration/models'],
});

export const superAiAgentsApi = new ApiCore({
  url: superadmin['/ai-agents'],
});

export const superAiAgentsReq = new ApiCore({
  url: superadmin['/ai-agents'],
});

export const apiPaginatedUsers = new ApiCore({
  url: superadmin['/paginated-users'],
});

export const resetUserPasswordSuperadminReq = new ApiCore({
  url: superadmin['/users/reset-password'],
});

export const jobHistoriesAPI = new ApiCore({
  url: superadmin['/job-histories'],
});

export const backgroundProcessesApi = new ApiCore({
  url: system['/job-histories'],
});

export const tenantActiveAiAgentApi = new ApiCore({
  url: system['/ai-agents/active'],
});

export const tenantRolesGET = new ApiCore({
  url: superadmin['/tenant-roles'],
});

export const superSmartsellAppVersionsApi = new ApiCore({
  url: superadmin['/smartsell/app-versions'],
});

export const superTenantAccessLogApi = new ApiCore({
  url: superadmin['/tenant/access-log'],
});

export const superAccessControlApi = new ApiCore({
  url: superadmin['/access-control'],
});

export const superAccessControlMetricsApi = new ApiCore({
  url: superadmin['/access-control-metrics'],
});

export const superAccessControlTenantMetricsApi = new ApiCore({
  url: superadmin['/access-control-tenants-metrics'],
});

export const reportsForSuperadminApi = new ApiCore({
  url: superadmin['/reports-for-superadmin'],
});

export const dbMapApi = new ApiCore({
  url: databaseManagement['/db-map'],
});

export const tableExtensionsApi = new ApiCore({ url: databaseManagement['/table-extensions'] });
export const tableExtensionOptionsApi = new ApiCore({ url: databaseManagement['/table-extensions/options'] });
